import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styles from './active.module.css';

const ActiveSkeleton = () => (
  <div className={styles.list}>
    {[1, 2, 3].map((i) => (
      <div key={i} className={styles.row}>
        <div className={styles.rowMain}>
          <Skeleton width={140} height={14} />
          <Skeleton width={90} height={12} style={{ marginTop: 6 }} />
        </div>
        <Skeleton width={80} height={12} />
      </div>
    ))}
  </div>
);

export const ActiveSubscriptions = ({ items = [], loading = false, onView = () => {} }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.title}>Active subscriptions</span>
        {!loading && items.length > 0 && <span className={styles.count}>{items.length}</span>}
      </div>

      {loading ? (
        <ActiveSkeleton />
      ) : items.length === 0 ? (
        <div className={styles.empty}>
          <p className={styles.emptyTitle}>No active subscriptions</p>
          <p className={styles.emptyBody}>
            Once a client is on a plan, their subscription shows up here.
          </p>
        </div>
      ) : (
        <div className={styles.list}>
          {items.map((item) => (
            <button key={item.id} className={styles.row} onClick={() => onView(item)}>
              <div className={styles.rowMain}>
                <span className={styles.dot} />
                <div className={styles.rowText}>
                  <span className={styles.client}>{item.client_name}</span>
                  <span className={styles.plan}>{item.plan}</span>
                </div>
              </div>
              <div className={styles.rowMeta}>
                {item.cost_label && <span className={styles.cost}>{item.cost_label}</span>}
                {item.expires_label && (
                  <span className={styles.renews}>Renews {item.expires_label}</span>
                )}
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
